<script>
export default {
    name: "ReverseCombinedModal",

    data() {

        return {
            memo: ``,
        };
    },

    props: {

        showModal: Boolean,
        invoice: Object,
    },

    computed: {

        reverseCombined() {

            return {
                patientName: this.invoice.names,
                txnDate: window.moment().format(`YYYY-MM-DD`),
                userName: this.$root.username,
                patientID: this.invoice.patientID,
                receiptnInvoiceNo: this.invoice.receiptnInvoiceNo,
                combinedID: this.invoice.combinedID,
                memo: this.memo,
            };
        },
    },

    methods: {

        reverseCombinedInvoice() {
            this.$root.loading=true;
            this.$http.post(`Accounts/ReverseCombinedPaynInvoice`, this.reverseCombined)
                .then(response => {
                    this.memo = ``;
                    this.$emit(`refresh`);
                    this.$root.loading=false;
                    this.$emit(`closeModal`);
                    window.Swal.fire({ type: `success`, text: response.data, });
                }).catch(() => { this.$root.loading=false; this.$emit(`closeModal`); });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 w-10/12">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Reverse Combined</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <div class="w-full flex flex-wrap bg-gray-300">
                <div class="md:w-1/4 w-1/2 p-tiny">
                    <h5 class="font-medium text-sm">Patient: {{ invoice.names }} </h5>
                </div>
                <div class="md:w-1/5 w-1/2 p-tiny">
                    <h5 class="font-medium text-sm">Visit No: {{ invoice.visitNo }} </h5>
                </div>
                <div class="md:w-1/5 w-1/2 p-tiny">
                    <h5 class="font-medium text-sm">Date: {{ invoice.txnDate | dateFormat }}</h5>
                </div>
                <div class="md:w-1/6 w-1/2 p-tiny">
                    <h5 class="font-medium text-sm">Invoice No: {{ invoice.receiptnInvoiceNo }}</h5>
                </div>
                <div class="md:w-1/6 w-1/2 p-tiny">
                    <h5 class="font-medium text-sm">Amount: {{ invoice.totalAmount | numberFormat }}</h5>
                </div>
            </div>
            <div class="w-full p-tiny">
                <label for="grid-memo" class="label-control">Memo:</label>
                <textarea id="grid-memo" v-model.trim="memo" required
                    cols="30" rows="2" class="input-control input-sm text-xs"></textarea>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded mr-6" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
        <button 
            @click.prevent="reverseCombinedInvoice"
            class="btn-primary btn-sm text-xs rounded">
                <i class="fa fa-undo"></i> Reverse Combined Invoice</button>
      </template>
    </tail-modal>
</template>